import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import HostLink from '../components/HostLink'
import Button from '../components/Button'
import { ErrorAlert, SuccessAlert } from '../components/Alert'
import { resendConfirmation } from '../api'
import { useDocumentTitle } from '../components/PublicLayout'

// Shown immediately after onboarding. The email is passed via router state
// (navigate('/check-inbox', { state: { email } })) or falls back to the value
// the user re-types into the resend form.
export default function CheckInbox() {
  useDocumentTitle('Check your inbox')
  const location = useLocation()
  const initialEmail = location.state?.email || ''

  const [email, setEmail] = useState(initialEmail)
  const [loading, setLoading] = useState(false)
  const [sentMsg, setSentMsg] = useState('')
  const [errMsg, setErrMsg] = useState('')

  async function handleResend(e) {
    e.preventDefault()
    setErrMsg('')
    setSentMsg('')
    setLoading(true)
    try {
      const res = await resendConfirmation(email)
      setSentMsg(res.message || 'A new confirmation link is on its way.')
    } catch (err) {
      setErrMsg(err.message || 'Could not resend. Please wait a moment and try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
        <div className="mx-auto mb-5 h-14 w-14 rounded-full bg-brand-100 text-brand-500 flex items-center justify-center text-2xl" aria-hidden>
          ✉
        </div>
        <h1 className="text-xl font-bold text-gray-900">Check your inbox</h1>
        <p className="mt-2 text-sm text-gray-600 leading-relaxed">
          We’ve sent a confirmation link{initialEmail ? ' to ' : ''}
          {initialEmail && <span className="font-medium text-gray-800">{initialEmail}</span>}.
          Click it to confirm your email and start your free trial. The link is
          valid for 48 hours.
        </p>
        <p className="mt-2 text-xs text-gray-500">
          Don’t see it? Check your spam folder, or resend below.
        </p>

        <form onSubmit={handleResend} className="mt-6 text-left">
          <label htmlFor="checkinbox-resend-email" className="block text-sm font-medium text-gray-700 mb-1">
            Resend to
          </label>
          <input
            id="checkinbox-resend-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@yournonprofit.org"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
          <div className="mt-3">
            <Button type="submit" variant="secondary" loading={loading} className="w-full">
              Resend confirmation email
            </Button>
          </div>
          <div className="mt-3 space-y-2">
            <SuccessAlert message={sentMsg} />
            <ErrorAlert message={errMsg} />
          </div>
        </form>

        <p className="mt-6 text-xs text-gray-500">
          <HostLink to="/" className="hover:text-brand-500">Back to Praenum</HostLink>
        </p>
      </div>
    </div>
  )
}
